export default __webpack_public_path__ + "static/19122-e7c5388dbf53724d80bc331502ef9c44.jpg";